import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import {
  getDeviceDetails,
  searchDeviceMgmt,
  getClientShipList,
  getClientShippingCompanyList
} from "../Actions/DeviceManagement";
import { getShipnameList, getCompanynameList } from "../Actions/HelpersAPI";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import swal from "sweetalert";
import Moment from "moment";
import axios from "axios";
import API from "../helpers/api";

const SearchItem = {
  id: "",
  make: "",
  model: "",
  manufacturingDate: "",
  lastCalibrationDate: "",
  nextCalibrationDate: "",
  companyName: "",
  maximumLimit: "",
  shipName: "",
  pageNumber: 1,
  pageSize: 25,
};
let user = JSON.parse(localStorage.getItem("currentUser"));

class DeviceManagementEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedManufacturingDate: "",
      SelectedFromDate: "",
      manufacturingDate: "",
      fromDate: "",
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
      searchData: {
        id: "",
        deviceId: "",
        make: "",
        model: "",
        manufacturingDate: "",
        lastCalibrationDate: "",
        nextCalibrationDate: "",
        companyName: "",
        shipName: "",
        maximumLimit: "",
        isDeleted: false,
        modifiedBy: user.email,
        pageNumber: 1,
        pageSize: 25,
        isActive: null
      },

    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleManufacturingDateChange = this.handleManufacturingDateChange.bind(
      this
    );
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openManufacturingDatePicker = this.openManufacturingDatePicker.bind(
      this
    );
    this.submitData = this.submitData.bind(this);
    this.handleOpenNextCallibration = this.handleOpenNextCallibration.bind(this);
    this.handleNextCallibrationDateChange = this.handleNextCallibrationDateChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, match, ShipcompanyName } = this.props;
    const { params } = match;
    const { id } = params;
    if (id) {
      dispatch(getDeviceDetails(id));
    }
    // dispatch(getShipnameList());
    dispatch(getCompanynameList());
    // dispatch(getClientShipList(ShipcompanyName));
    this.props.dispatch(getClientShippingCompanyList(ShipcompanyName));
  }


  static getDerivedStateFromProps(nextProps, prevState) {
    const { match, dispatch, DeviceDetails } = nextProps;
    const { params } = match;
    const { id } = params;
    if (DeviceDetails && DeviceDetails !== "") {
      prevState.contractDetail = DeviceDetails;
      prevState.searchData.id = DeviceDetails.id;
      prevState.searchData.deviceId = DeviceDetails.deviceId;
      prevState.searchData.make = DeviceDetails.make;
      prevState.searchData.model = DeviceDetails.model;
      prevState.searchData.manufacturingDate = DeviceDetails.manufacturingDate;
      prevState.searchData.lastCalibrationDate = DeviceDetails.lastCalibrationDate;
      prevState.searchData.nextCalibrationDate = DeviceDetails.nextCalibrationDate;
      prevState.searchData.companyName = DeviceDetails.companyName ? DeviceDetails.companyName : "";
      prevState.searchData.shipName = DeviceDetails.companyName === null ? "" : DeviceDetails.shipName;
      prevState.searchData.maximumLimit = DeviceDetails.maximumLimit ? DeviceDetails.maximumLimit : DeviceDetails.maximumLimit == 0 ? 0 : "";
      prevState.searchData.isActive = DeviceDetails.isActive ? DeviceDetails.isActive : DeviceDetails.isActive == false ? false : null;
      dispatch({ type: "getDeviceDetailsSuccess", data: "" });
    }
  }

  submitData() {
    const { dispatch } = this.props;
    if (this.state.searchData.companyName !== "" && this.state.searchData.id !== "" && this.state.searchData.lastCalibrationDate !== "" && this.state.searchData.nextCalibrationDate !== "" &&
      this.state.searchData.make !== "" && this.state.searchData.model !== "" && this.state.searchData.shipName !== "" && this.state.searchData.manufacturingDate !== "" && this.state.searchData.maximumLimit !== "" && this.state.searchData.isActive !== undefined && this.state.searchData.isActive !== null) {
      var decimals = this.state.searchData.maximumLimit - Math.floor(this.state.searchData.maximumLimit);
      if (decimals === 0) {
        this.state.searchData.maximumLimit = Math.round(this.state.searchData.maximumLimit);
        this.setState({})
      }
      else {
        this.state.searchData.maximumLimit = Number(this.state.searchData.maximumLimit);
        this.setState({})
      }
      let url = `${API.UpdateDevice}`;
      axios
        .put(url, this.state.searchData)
        .then((response) => {
          dispatch(searchDeviceMgmt(SearchItem));
          this.cancel();
          toast.success("Updated Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch({
            type: "PutDeviceDetailSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          swal("Error!", "Something went wrong. Please try again.", "warning");
          dispatch({
            type: "PutDeviceDetailFailure",
            error: "ERROR",
          });
        });
    } else if (this.state.searchData.id === "") {
      swal('Error!', 'Device Id is mandatory', 'warning');
    }
    else if (this.state.searchData.make === "") {
      swal('Error!', 'Make is mandatory', 'warning');
    }
    else if (this.state.searchData.model === "") {
      swal('Error!', 'Model is mandatory', 'warning');
    } else if (this.state.searchData.manufacturingDate === "") {
      swal('Error!', 'Manufacturing Date is mandatory', 'warning');
    }
    else if (this.state.searchData.lastCalibrationDate === "") {
      swal('Error!', 'Last Calibration Date is mandatory', 'warning');
    }
    else if (this.state.searchData.nextCalibrationDate === "") {
      swal('Error!', 'Next Calibration Date is mandatory', 'warning');
    }
    else if (this.state.searchData.companyName === "") {
      swal('Error!', 'Company Name is mandatory', 'warning');
    } else if (this.state.searchData.shipName === "") {
      swal('Error!', 'Ship Name is mandatory', 'warning');
    } else if (this.state.searchData.maximumLimit === "") {
      swal('Error!', 'Maximum Limit is mandatory', 'warning');
    }
    else if (this.state.searchData.isActive === undefined || this.state.searchData.isActive === null) {
      swal('Error!', 'Is Active is mandatory', 'warning');
    }
  }
  handleBlur() {
    this.setState({
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
      nextCalibrationDateIsOpen: false
    });
  }

  handleFromDateChange(date) {
    const momentDate = Moment(date);
    const nextDate = momentDate.add(1, 'years');
    // this.state.searchData.lastCalibrationDate = Moment(
    //   new Date(Date.parse(date))
    // ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
      searchData: {
        ...this.state.searchData,
        lastCalibrationDate: Moment(new Date(Date.parse(date))).format("YYYY-MM-DD"),
        nextCalibrationDate: Moment(new Date(Date.parse(nextDate))).format("YYYY-MM-DD")
      }
    });
  }

  handleManufacturingDateChange(date) {
    this.state.searchData.manufacturingDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedManufacturingDate: date,
      manufacturingDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openManufacturingDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      manufacturingDatePickerIsOpen: !this.state.manufacturingDatePickerIsOpen,
    });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "companyName") {
      this.state.searchData[nodeName] = e.target.value;
      this.state.searchData.shipName = "";
      this.props.dispatch(getClientShippingCompanyList(e.target.value));
      // this.props.dispatch(getClientShipList(e.target.value));
    }
    if (nodeName === "maximumLimit") {
      var pattern = /^[0-9]*\.?[0-9]*$/;
      if (pattern.test(e.target.value)) {
        const phone = e.target.validity.valid ? e.target.value : this.state.searchData.maximumLimit;
        this.state.searchData[nodeName] = phone;
        this.setState({});
      }
    } else {
      this.state.searchData[nodeName] = e.target.value;
      this.setState({});
    }
  }

  onclickShipname = () => {
    if (this.state.searchData?.companyName?.trim().length > 0) {
      if (this.props.ClientShipLists2?.length > 0) {

      } else {
        toast.error("There is no ships assigned for this company.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please choose the company to select the ship.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  cancel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Device");
  };

  BacktoPrevious() {
    this.props.history.goBack();
  }

  handleOpenNextCallibration() {
    this.setState({
      manufacturingDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
      nextCalibrationDateIsOpen: !this.state.nextCalibrationDateIsOpen
    });
  }

  handleNextCallibrationDateChange(date) {
    this.setState({
      searchData: {
        ...this.state.searchData,
        nextCalibrationDate: Moment(
          new Date(Date.parse(date))
        ).format("YYYY-MM-DD")
      },
      fromDatePickerIsOpen: false,
      manufacturingDatePickerIsOpen: false,
      nextCalibrationDateIsOpen: false
    })
  }

  render() {
    const { showSidePane, ShipNameList, CompanyList, ClientShipLists, ClientShipLists2 } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row ">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-1 pl-3 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Update Device
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box pb-4">
                  <div className="row">
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">ID</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="id"
                        placeholder="ID"
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.searchData.id}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Make</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="make"
                        placeholder="Make"
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.searchData.make}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Model</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="model"
                        placeholder="model"
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.searchData.model}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Manufacturing Date</label>
                      <br></br>
                      <div
                        className="input-group add-on date datepicker"
                        data-date-format="yyyy-mm-dd"
                      >
                        <input
                          type="text"
                          value={Moment(
                            new Date(
                              Date.parse(
                                this.state.searchData.manufacturingDate
                              )
                            )
                          ).format("YYYY-MM-DD")}
                          className="form-control date-picker"
                          placeholder="Manufacturing Date"
                          name="manufacturingDate"
                        ></input>
                        <DatePicker
                          onChange={this.handleManufacturingDateChange}
                          open={this.state.manufacturingDatePickerIsOpen}
                          onClickOutside={this.handleBlur}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date"
                        />
                        <div
                          className="input-group-btn calendar-icon"
                          onClick={this.openManufacturingDatePicker}
                        >
                          <button
                            className="btn btn-default"
                            style={{ height: "100%" }}
                          >
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">
                        Last Calibration Date
                      </label>
                      <br></br>
                      <div
                        className="input-group add-on date datepicker"
                        data-date-format="yyyy-mm-dd"
                      >
                        <input
                          type="text"
                          value={Moment(
                            new Date(
                              Date.parse(
                                this.state.searchData.lastCalibrationDate
                              )
                            )
                          ).format("YYYY-MM-DD")}
                          className="form-control date-picker"
                          placeholder="Last Calibration Date"
                          name="lastCalibrationDate"
                        ></input>
                        <DatePicker
                          onChange={this.handleFromDateChange}
                          open={this.state.fromDatePickerIsOpen}
                          onClickOutside={this.handleBlur}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date"
                        />
                        <div
                          className="input-group-btn calendar-icon"
                          onClick={this.openFromDatePicker}
                        >
                          <button
                            className="btn btn-default"
                            style={{ height: "100%" }}
                          >
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Next Calibration Date</label>
                      <br></br>
                      <div
                        className="input-group add-on date datepicker"
                        data-date-format="yyyy-mm-dd"
                      >
                        <input
                          type="text"
                          value={Moment(
                            new Date(
                              Date.parse(
                                this.state.searchData.nextCalibrationDate
                              )
                            )
                          ).format("YYYY-MM-DD")}
                          className="form-control date-picker"
                          placeholder="Next Calibration Date"
                          name="nextCalibrationDate"
                        ></input>
                        <DatePicker
                          onChange={this.handleNextCallibrationDateChange}
                          open={this.state.nextCalibrationDateIsOpen}
                          onClickOutside={this.handleBlur}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date"
                        />
                        <div
                          className="input-group-btn calendar-icon"
                          onClick={this.handleOpenNextCallibration}
                        >
                          <button
                            className="btn btn-default"
                            style={{ height: "100%" }}
                          >
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Company Name</label>
                      <br></br>
                      <select
                        className="form-control"
                        name="companyName"
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.searchData.companyName}
                      >
                        <option value="">Select Company Name</option>
                        {CompanyList &&
                          CompanyList.map((company) => (
                            <option value={company.clientName}>
                              {company.clientName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Ship Name</label>
                      <br></br>
                      <select
                        className="form-control"
                        name="shipName"
                        value={this.state.searchData.shipName}
                        onClick={this.onclickShipname}
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value="">Select Ship Name</option>
                        {ClientShipLists2.length !== 0 ?
                          (ClientShipLists2 &&
                            ClientShipLists2.map((ships) =>
                              ships.shipName ===
                                this.state.searchData.shipName ? (
                                <option value={ships.shipName} selected>
                                  {ships.shipName}
                                </option>
                              ) : (
                                <option value={ships.shipName}>
                                  {ships.shipName}
                                </option>))) :
                          (
                            <option value="">
                              No Ships to display
                            </option>
                          )}

                      </select>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Maximum Limit</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="maximumLimit"
                        placeholder="Maximum Limit"
                        value={this.state.searchData.maximumLimit}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    {/* Is active added */}
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label required">Is Active</label>
                      <br></br>
                      <div className="d-flex">
                        <input
                          style={{ height: '20px', width: '20px' }}
                          type="checkbox"
                          name="isActive"
                          id="activeyes"
                          className="mr-2"
                          checked={this.state.searchData?.isActive === true}
                          onChange={() =>
                            this.setState((prevState) => ({
                              searchData: {
                                ...prevState.searchData,
                                isActive: true
                              }
                            }))
                          }
                        ></input>
                        <label htmlFor="activeyes" className="form-label mr-3 mt-0">Yes</label>
                        <input
                          style={{ height: '20px', width: '20px' }}
                          type="checkbox"
                          name="isActiveNo"
                          id="activeno"
                          className="mr-2"
                          checked={this.state.searchData?.isActive === false}
                          onChange={() =>
                            this.setState((prevState) => ({
                              searchData: {
                                ...prevState.searchData,
                                isActive: false
                              }
                            }))
                          }
                        ></input>
                        <label htmlFor="activeno" className="form-label mt-0">No</label>
                      </div>
                    </div>
                    <div className={showSidePane ? "col-lg-6" : "col-lg-8"}>
                      <br></br>
                      <div
                        className="search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="Update"
                          onClick={() => this.submitData()}
                        >
                          Update
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.cancel()}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    DeviceDetails: state.DeviceManagementReducer.DeviceDetails,
    ShipNameList: state.UserManageReducer.ShipNameList,
    CompanyList: state.UserManageReducer.CompanyList,
    ShipcompanyName: state.DeviceManagementReducer.ShipcompanyName,
    ClientShipLists: state.DeviceManagementReducer.ClientShipLists || [],
    ClientShipLists2: state.DeviceManagementReducer.ClientShipLists2 || []
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceManagementEdit);
